/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useElementDidResize from 'components/hooks/useElementDidResize';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function HideableContainer({
  hidden,
  children,
  className,
  style,
  ...props
}) {
  const [height, setHeight] = useState(500);
  const ref = useRef();

  useElementDidResize(ref, (_, target) => {
    setHeight(target.height);
  });

  return (
    <div
      ref={ref}
      className={classNames(
        Styles.mainContainer,
        className,
        { [Styles.mainContainerHidden]: hidden },
      )}
      // style={{ maxHeight: hidden ? 0 : height, ...style }}
      {...props}
    >
      {children}
    </div>
  );
}

HideableContainer.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

HideableContainer.defaultProps = {
  hidden: false,
  children: null,
  className: '',
  style: {},
};
